<template>
  <div class="register-btn">
    <div class="friend" v-if="channelName">
      您的好友<span>{{ channelName }}</span
      >，诚邀您注册麦德通账号
    </div>
    <div class="register-btn__wx" @click="goMiniPrograme(REGISTER_TYPE.WX)">
      微信登录/注册
    </div>
    <div
      class="register-btn__phone"
      @click="goMiniPrograme(REGISTER_TYPE.PHONE)"
    >
      手机号登录/注册
    </div>
    <div
      class="register-btn__agree-wrap"
      style="text-align:left;margin-left:10px"
    >
      <i
        :class="[
          'register-btn__select iconfont',
          agree
            ? 'icon-gouwuche-xuanzhong is-selected'
            : 'icon-gouwuche-weixuanzhong'
        ]"
        @click="agreeClick"
      ></i>
      <span class="register-btn__agree" style="margin-top:2px">
        同意并遵守
        <router-link class="register-btn__agree-item" to="/agreezc?agreementType=0"
          >《{{getAgreementObj(0)}}》</router-link
        >和
        <router-link class="register-btn__agree-item" to="/agreezc?agreementType=7"
          >《{{getAgreementObj(7)}}》</router-link
        >
      </span>
    </div>
    <LoadingModal :show="showLoading" />
  </div>
</template>

<script>
import { linkToProgram, channelNo, getInviteInfo, getAgreementData } from '@/api/land.js'
import { isMobile, redirectToUser, getCookie, getQuery } from '@/util/util'
import { mixinGetDeviceId } from '@/util/mixins'
import { mixinCheckResponseIsErr } from '@ost/static/lib/mixin'
import LoadingModal from './loadingModal.vue'

// 商户端，注册方式
const REGISTER_TYPE = {
  PHONE: 1, // 手机号
  WX: 2 // 微信
}

export default {
  name: 'RegisterBtn',
  components: { LoadingModal },
  mixins: [mixinCheckResponseIsErr, mixinGetDeviceId],
  props: {
    // 页面来源
    pageType: {
      type: String,
      require: false,
      default: ''
    },
    // 是否能注册
    canRegister: {
      type: Boolean,
      require: false,
      default: true
    },
    // 不能注册的错误信息提示
    errMsg: {
      type: String,
      require: false,
      default: ''
    }
  },
  data () {
    return {
      agreementList: [],
      agree: false, // 勾选协议
      channelNo: null, // 渠道码
      isValidChannelNo: false, // 渠道码是否有效
      channelName: '',
      showLoading: false
    }
  },
  computed: {
    REGISTER_TYPE () {
      return REGISTER_TYPE
    }
  },
  created () {
    getAgreementData({agreementTypeList: [0, 7]}).then(res => {
      if (res.code == 0) {
        this.agreementList = res.data || []
      }
    })
    this.channelCode = getCookie('channelCode') || ''
    this.checkChannel()
  },
  methods: {
    getAgreementObj (agrreementType) {
      return this.agreementList?.find(x => x.agreementType == agrreementType)?.userProtocolName || ''
    },
    /**
     * @description 用户协议
     */
    agreeClick () {
      this.agree = !this.agree
    },
    /**
     * @description 检验channelNo
     */
    async checkChannel () {
      if (!this.channelCode) {
        return
      }
      this.showLoading = true
      const res = await channelNo({ channelId: this.channelCode }).catch(
        e => null
      )
      this.showLoading = false
      if (!res || res.code !== 0) {
        return
      }

      if (res.rows.length > 0) {
        // 有效
        this.isValidChannelNo = true
        this.$emit('channelNo', 'true')
        let str = res.rows[0].channelName
        let channelName = ''
        if (str) {
          let arr = str.split('')
          arr = arr.map((a, i) => {
            if (i > 2 && i < 7) {
              return '*'
            }
            return a
          })
          channelName = arr.join('')
        }
        this.channelName = channelName
      } else {
        // 无效，清除cookie
        this.isValidChannelNo = false
        this.channelName = ''
        this.$toast({
          message: `该注册码(${this.channelCode}获取到的渠道码)有误，请联系您的客服经理`
        })
        this.$emit('channelNo', 'false')
      }
    },
    /**
     * 打开小程序
     * @param {*} registerType
     */
    async goMiniPrograme (registerType) {
      const query = getQuery()
      let channelNo =
        query.channelNo || query.channelCode || getCookie('channelCode') || ''
      let param = {}
      let intoWay = ''

      if (this.pageType === 'land8') {
        param.register_method =
          registerType === REGISTER_TYPE.WX
            ? '微信用户一键登录'
            : '输入手机号登录/注册'
        // 扫码方式
        if (this.$route.query.fromPage === 'PC') {
          param.into_way = '扫码'
          intoWay = 'qrCode'
        }
        if (this.$route.query.fromType == 1) {
          param.into_way = '复制链接'
          intoWay = 'copyUrl'
        }
      }

      const isValid = await this.checkCanRegister().catch(e => null)
      if (!isValid) {
        return
      }

      if (!isMobile()) {
        // pc端
        let pointType = ''
        if (param.into_way) {
          pointType = `&pointType=${param.into_way}`
        }
        let activityType = ''
        if (this.$route.query.activityType) {
          activityType = `&activityType=${this.$route.query.activityType}`
        }
        redirectToUser(
          `user/register?registerType=${registerType}&channelNo=${channelNo}${pointType}${activityType}`,
          '_blank'
        )
        return
      }

      // 默认微信登录
      let path = 'minePages/pages/Login/index'

      if (registerType === REGISTER_TYPE.PHONE && this.pageType !== 'land8') {
        // 手机号登录/注册
        path = 'minePages/pages/Login/index'
      } else if (this.pageType === 'land8') {
        if (this.$route.query.activityType == 2) {
          path = 'minePages/pages/newRegistered3/index'
        } else {
          path = 'minePages/pages/newRegistered2/index'
        }
      }

      let linkParam = {
        path,
        channelNo: channelNo,
        isAgree: true,
        activityType: this.$route.query.activityType
      }
      if (intoWay) {
        linkParam.intoWay = intoWay
      }

      let res = await linkToProgram(linkParam).catch(e => null)

      if (this.checkResponseIsErr(res)) {
        return
      }

      window.location.href = res.data
    },
    /**
     * 检查是否能进行注册
     */
    async checkCanRegister () {
      // 校验协议
      if (this.channelCode && !this.isValidChannelNo) {
        // 无效的渠道码，不给注册
        this.$toast({
          message: `该注册码(${this.channelCode}获取到的渠道码)有误，请联系您的客服经理`
        })
        return false
      } else if (!this.canRegister) {
        this.$toast({
          message: this.errMsg
        })
        return false
      }

      if (this.pageType === 'land8' && this.$route.query.activityType != 2) {
        // 老带新，要校验活动是否已经结束
        const isValidInvite = await this.checkInviteIsValid(
          this.channelCode
        ).catch(e => null)

        if (!isValidInvite) {
          // 老带新活动已经结束
          this.inviteIsEnd()

          return false
        }
      }

      return true
    },
    /**
     * 校验老带新活动是否有效
     * @param {*} channelNo 渠道码
     */
    async checkInviteIsValid (channelNo) {
      if (!channelNo) {
        return false
      }

      const deviceId = await this.getDeviceId()
      const param = { code: channelNo, deviceId }

      if (this.$route.query.activityType == 3) {
        // 推荐官计划
        param.inviteActivityType = 1
      }

      const res = await getInviteInfo(param).catch(e => null)

      if (this.checkResponseIsErr(res)) {
        return false
      }

      return !!res.data
    },
    /**
     * 老带新活动已结束
     */
    inviteIsEnd () {
      this.$dialog
        .confirm({
          message: '抱歉，活动已结束，已为您选择其他方式注册；是否继续？',
          confirmButtonText: '继续'
        })
        .then(() => {
          window.location.href = process.env.VUE_APP_MDT_MOBILE_URL
        })
    }
  }
}
</script>

<style lang="less" scoped>
.register-btn {
  position: fixed;
  left: 0;
  bottom: 0;
  box-sizing: border-box;
  width: 100%;
  height: 170px;
  padding: 12px 15px;
  background-color: #fff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);

  &__wx {
    height: 35px;
    border-radius: 18px;
    margin-bottom: 12px;
    background: #1363f7;
    text-align: center;
    font-family: PingFang SC;
    font-size: 14px;
    line-height: 35px;
    color: #ffffff;
    cursor: pointer;
    user-select: none;
  }

  &__phone {
    box-sizing: border-box;
    height: 35px;
    border: 1px solid #1363f7;
    border-radius: 18px;
    margin-bottom: 11px;
    background: #ffffff;
    text-align: center;
    font-family: PingFang SC;
    font-size: 15px;
    line-height: 35px;
    color: #1363f7;
    cursor: pointer;
    user-select: none;
  }

  &__agree-wrap {
    display: flex;
    align-items: center;
  }

  &__select {
    margin-right: 8px;
    font-size: 20px;
    line-height: 17px;
    color: #1363f7;
    cursor: pointer;
    user-select: none;
  }

  &__agree {
    font-family: PingFangSC-Regular, PingFang SC;
    font-size: 12px;
    line-height: 17px;
    color: #333333;

    &-item {
      color: #1363f7;
    }
  }
}

.friend {
  font-size: 14px;
  color: #333;
  text-align: center;
  margin-bottom: 10px;
}

.friend span {
  color: #0077ff;
}
</style>



// WEBPACK FOOTER //
// src/components/RegisterBtn.vue